import { QueryClient } from '@tanstack/react-query';

export const createQueryClient = () => {
    return new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 5 * 60 * 1000, // 5 minutes
                refetchOnWindowFocus: true,
                refetchOnReconnect: true,
                retry: (failureCount, error: any) => {
                    // Don't retry on 404s
                    if (error?.status === 404) return false;
                    // Don't retry more than 3 times
                    return failureCount < 3;
                },
            },
            mutations: {
                onError: (error) => {
                    console.error('Mutation failed:', error);
                },
            },
        },
    });
};

// Global query client instance
export const queryClient = createQueryClient();
